var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt20"},[_c('div',{staticClass:"design_box_out"},[_c('p',{staticClass:"design_box_out_title"},[_c('i',{staticClass:"iconfont iconyou"}),_vm._v(_vm._s(_vm.property.label))]),_c('div',{staticClass:"company-desc design_box"},[_vm._v("\n        "+_vm._s(_vm.property.body)+"\n      ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }